module.exports = __webpack_public_path__ + "img/woocommerce.58a90441.png";